import API from 'shared/api/API';
import { GET } from 'shared/utils/Executer';

class KnowledgeCategoriesAPI {
  /**
   * Get all knowledge categories for the current user's organization and workspaces
   * Note: This endpoint uses the user's organizationId and workspaces from their JWT token
   * @returns {Promise<Object>} Categories array
   */
  async getCategories() {
    return await API.client.execute(GET, '/v1/knowledge/categories');
  }

  /**
   * Get category by ID
   * @param {string} categoryId - Category ID
   * @returns {Promise<Object>} Category details
   */
  async getCategoryById(categoryId) {
    return await API.client.execute(GET, `/v1/knowledge/categories/${categoryId}`);
  }
}

export default new KnowledgeCategoriesAPI();
